const prefix = 'fasr';
const iconName = 'bold';
const width = 384;
const height = 512;
const aliases = [];
const unicode = 'f032';
const svgPathData = 'M0 32H24 48 72 88h24H212c68.5 0 124 55.5 124 124c0 34.7-14.3 66.2-37.3 88.7C339.7 264.9 368 307.1 368 356c0 68.5-55.5 124-124 124H112 88 72 48 24 0V432H24 48V256 80H24 0V32zM96 432h16H244c42 0 76-34 76-76s-34-76-76-76H212 96V432zm0-200H212c42 0 76-34 76-76s-34-76-76-76H112 96V232z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
